import { createRouter, createWebHistory } from 'vue-router'

const appUrl = import.meta.env.VITE_APP_URL

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/projects'
    },
    {
      path: '/home',
      name: 'home_TBD',
      component: () => import('@/views/HomeView.vue')
    },
    {
      name: 'login',
      path: '/login',
      redirect: () => {
        window.location.href = appUrl + '/.auth/login/aad'
        return '/redirect'
      }
    },
    {
      name: 'redirect',
      path: '/redirect',
      redirect: '/redirect'
    },
    {
      path: '/projects/:id?',
      name: 'projects',
      component: () => import('@/views/projects/ProjectsOverview.vue')
    },
    {
      path: '/projects/:id',
      alias: '/project/:id',
      name: 'ProjectDetailsView',
      component: () => import('@/views/projects/ProjectDetailsView.vue')
    },
    {
      path: '/projects/:id/print',
      alias: '/project/:id/print',
      name: 'PrintProject',
      meta: { layout: 'print' },
      component: () => import('@/views/projects/ProjectPrintView.vue')
    },
    {
      path: '/projects/new-project',
      name: 'newWindsiteProject',
      component: () => import('@/views/projects/NewProjectView.vue')
    },
    {
      path: '/prospects',
      name: 'prospects',
      component: () => import('@/views/prospecting/ProspectingOverview.vue')
    },
    {
      path: '/prospects/:id',
      name: 'ProspectingDetailView',
      component: () => import('@/views/prospecting/ProspectingDetailView.vue')
    },
    {
      path: '/prospects/new-prospect',
      name: 'newProspectArea',
      component: () => import('@/views/prospecting/NewProspectView.vue')
    }
  ]
})

export default router
